import QuizStatuses from '@/constants/QuizStatuses'

export default {
  isEnableABTestQuiz: (state) => {
    if (!state.presentation) return false
    if (state.presentation.userId % 10 > 2) return true
    return false
  },
  isWaitingQuizResult: (state) => {
    const { slide, presentation } = state
    if (!slide) return false
    if (!presentation.manualRevealCorrectAnswers) return false
    return slide.type === 'pickAnswer' && slide.quizStatus === QuizStatuses.RESULT_SCREEN && !slide.showCorrectOption
  },
  canShowQuizResult: (state) => {
    const isResultScreen = state.slide.quizStatus === QuizStatuses.RESULT_SCREEN
    if (!state.presentation.manualRevealCorrectAnswers || state.presentation.audiencePacing) {
      return isResultScreen
    }
    return state.slide.showCorrectOption && isResultScreen
  },
}
